module.exports = "/lucky-balls/img/drum/drum_loop_004.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_004.png
// module id = 1019
// module chunks = 0